import type { PropertyDataFields } from '@brimo/shared';

type DescriptionKey =
  | 'locationDescription'
  | 'surroundingsDescription'
  | 'objectDescription'
  | 'specialFeatures'
  | 'additionalInformation';

/** The five texts of „Beschreibung" in reading order with their German headings. */
export const DESCRIPTION_FIELDS: { key: DescriptionKey; label: string }[] = [
  { key: 'locationDescription', label: 'Lage' },
  { key: 'surroundingsDescription', label: 'Umgebung' },
  { key: 'objectDescription', label: 'Objekt' },
  { key: 'specialFeatures', label: 'Besonderheiten' },
  { key: 'additionalInformation', label: 'Weitere Informationen' },
];

/** Non-empty texts only (whitespace counts as empty). */
export function descriptionSections(
  fields: Pick<PropertyDataFields, DescriptionKey>,
): { key: DescriptionKey; label: string; text: string }[] {
  return DESCRIPTION_FIELDS.flatMap(({ key, label }) => {
    const text = fields[key]?.trim() ?? '';
    return text ? [{ key, label, text }] : [];
  });
}
